export default __webpack_public_path__ + "static/media/marker.aece8925.svg";